import React, { useState } from 'react';
import { Col, Row, Card, Button } from "antd";
import { LeftOutlined, RightOutlined, SwapOutlined } from '@ant-design/icons';
import WorkflowTree from './workflowTree';
import '../assets/styles/common.css';
import WorkflowTab from './workflowTab';

const WorkFlowManage = () => {
    const [selectedWorkflowName, setSelectedWorkflowName] = useState('');
    const [selectedWorkflowId, setSelectedWorkflowId] = useState('');
    const [selectedCatId, setSelectedCatId] = useState(null);
    const [showLeft, setShowLeft] = useState(true);

    const onTreeSelect = (data) => {
        setSelectedWorkflowId(data.wfId);
        setSelectedWorkflowName(data.wfName);
        setSelectedCatId(data.wfCategoryId || 0);
    };

    return (
        <div>
            <Row style={{ marginBottom: "10px" }}>
                <Col span={24}>
                    <span style={{ fontSize: "1rem", marginRight: "15px" }}><b>Workflow Management</b></span>
                    <span style={{ fontWeight: "normal" }}>Manage workflows by create <b>Worklow</b>, <b>Meta Data</b>, <b>Workflow Component Configurations </b>
                        and <b>Search the meta data</b></span>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {/* <div style={{ display: "flex", gap: "10px" }}> */}
                    <Row gutter={16}>
                        {showLeft && (
                            <Col span={5}>
                                {/* <Card className="cus-tree-card" title="Workflow List" style={{ padding: "0px" }}> */}
                                <Card className="cus-tree-card" style={{ padding: "0px" }}>
                                    <WorkflowTree onTreeSelect={onTreeSelect} />
                                </Card>
                            </Col>
                        )}

                        <Col span={showLeft ? 19 : 24}>
                            {/* <div style={{ flex: 1 }} > */}

                            {selectedWorkflowId ? (
                                <>
                                    <Row>
                                        <Col span={24}>
                                            <Button
                                                type="text"
                                                icon={<SwapOutlined />}
                                                onClick={() => setShowLeft(!showLeft)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '25px',
                                                    left: showLeft ? '-34px' : "0",
                                                    transform: 'translateY(-50%)',
                                                    background: '#fff',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '50%',
                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                    zIndex: 10,
                                                }}
                                            />
                                            <span className="step-title"><b>{selectedWorkflowName}</b></span>

                                            {/* <h3 style={{ marginLeft: showLeft ? '10px' : "40px" }}>{selectedWorkflowName}</h3> */}
                                        </Col>
                                        <Col span={24}>
                                            <WorkflowTab wfId={selectedWorkflowId} wfCatId={selectedCatId} wfName={selectedWorkflowName} />
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <Row>
                                    <Col span={24}>
                                        <Card className="cus-tree-card0" title="Workflow Details">Select a workflow to view details</Card>
                                    </Col></Row>
                            )}

                            {/* </div> */}
                        </Col>
                    </Row>
                    {/* </div> */}
                </Col>
            </Row >
        </div >
    );
};

export default WorkFlowManage;